import { forwardRef, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaViewerComponent } from './media-viewer.component';
import { MediaViewerService } from './media-viewer.service';
import { MEDIA_VIEWER_ADAPTER } from '@shared/modules/media/media-viewer-adapter';
import { CwtMediaModule } from '@shared/modules/media/media.module';
import { CwtIonicModule } from '../../../../modules/ionic';



@NgModule({
  declarations: [
    MediaViewerComponent
  ],
  imports: [
    CommonModule,
    CwtIonicModule,
    CwtMediaModule,
  ],
  exports: [
    MediaViewerComponent
  ],
  providers: [
    MediaViewerService
  ]
})
export class MediaViewerModule {
  static forRoot(): ModuleWithProviders<MediaViewerModule> {
    return {
      ngModule: MediaViewerModule,
      providers: [
        { provide: MEDIA_VIEWER_ADAPTER, useExisting: forwardRef(() => MediaViewerService) }
      ]
    };
  }
}
